import React from "react"
import { FormikTextField } from "../../../../../../../shared/components/forms/Formik"
import { PrivateCompanyDetailsFormValues } from "../../billReceiversTypes"
import { DetailsAddressFormSection } from "./DetailsAddressFormSection"
import { DetailsContactFormSection } from "./DetailsContactFormSection"
import { LocalizedStrict } from "../../../../../../localization/components/AppLocalized"

type PrivatePersonProps = Readonly<{
    isMerchantAdmin: boolean
}>

export function PrivateCompanyForm({ isMerchantAdmin }: PrivatePersonProps) {
    return (
        <>
            {isMerchantAdmin && (
                <LocalizedStrict
                    id="bill-receivers-form-label-debtor-number"
                    attrs={{ label: true, placeholder: true }}
                >
                    <FormikTextField<PrivateCompanyDetailsFormValues>
                        name="debtorNumber"
                        label="Debtor number"
                        placeholder="Identifier of debtor in your accounting system"
                        fullWidth
                    />
                </LocalizedStrict>
            )}
            <LocalizedStrict id="bill-receivers-form-label-company-name" attrs={{ label: true }}>
                <FormikTextField<PrivateCompanyDetailsFormValues>
                    name="companyName"
                    label="Company name (*)"
                    fullWidth
                />
            </LocalizedStrict>
            <DetailsAddressFormSection />
            <DetailsContactFormSection />
        </>
    )
}
